refreshedUuid